'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react.PropTypes.oneOfType([(0, _RecordPropType2.default)('CompanyChatHeadingConfig'), (0, _RecordPropType2.default)('OwnerChatHeadingConfig'), (0, _RecordPropType2.default)('UsersAndTeamsChatHeadingConfig')]);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/chat-heading-config/prop-types/ChatHeadingConfigPropType.js
// module id = 26
// module chunks = 2 3